// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".property-tags .el-tag+.el-tag{margin-left:10px}", ""]);
// Exports
module.exports = exports;
